module.exports = __webpack_public_path__ + "static/img/jsxt.eb59375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jsxt.png
// module id = HScg
// module chunks = 0